import React, { useState } from "react";
import { FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { dismissPortalNotice, readPortalNotice } from "../context/PortalHostContext";
import "../assets/css/PortalNoticeBanner.css";

/** Sign-in warnings kept until login emails and portal hosts are enforced. */
function PortalNoticeBanner() {
  const [notice, setNotice] = useState(() => readPortalNotice());
  if (!notice) return null;

  const close = () => {
    dismissPortalNotice();
    setNotice(null);
  };

  return (
    <div className="portal-notice" role="status">
      <FaExclamationTriangle className="portal-notice__icon" aria-hidden="true" />
      <div className="portal-notice__body">
        {notice.hostMismatch && notice.expectedHost ? (
          <p>
            Please sign in at{" "}
            <a href={notice.url || `https://${notice.expectedHost}`}>{notice.expectedHost}</a> from now on.
            This address will stop working for your account soon.
          </p>
        ) : null}
        {notice.emailIssue ? (
          <p>
            {notice.emailIssue} Please ask your administrator to update your login email before it is
            enforced.
          </p>
        ) : null}
      </div>
      <button type="button" className="portal-notice__close" onClick={close} aria-label="Dismiss">
        <FaTimes />
      </button>
    </div>
  );
}

export default PortalNoticeBanner;
